<template>
  <span>
    <v-card-title>
      Selecionar Fase
    </v-card-title>
    <v-card-text>
      Escolha a Fase correspondente ao(s) pedido(s) selecionado(s):
      <div class="mt-3">
        <perfect-scrollbar class="fs-box-pedidos-selecionados">
          <span v-for="(pedido, index) in pedidosSelecionados" :key="index">
            ID: <b>{{ pedido.id.padStart(7, '0') }}</b> | Data: <b>{{ formatarData(pedido.created_at) }}</b> | Cliente: <b>{{ pedido.nome }}</b><br>
          </span>
        </perfect-scrollbar>
      </div>
      <v-select
        :items="fases"
        v-model="faseSelecionada"
        label="Selecionar Fase"
        item-text="nome_fase"
        item-value="id"
        placeholder=" "
        class="mt-5"
        outlined
        dense
      ></v-select>
      <v-card-actions style="padding: 0px">
        <v-spacer></v-spacer>
        <v-btn color="#2A2F50" @click="selecionarFase()" dark small>
          <v-icon class="mr-1" style="font-size: 15px !important">mdi-checkbox-marked-circle-outline</v-icon>
          Selecionar
        </v-btn>
        <v-btn color="warning" @click="fecharDialog()" dark small>
          <v-icon class="mr-1" style="font-size: 15px !important">mdi-close</v-icon>
          Fechar
        </v-btn>
      </v-card-actions>
    </v-card-text>
  </span>
</template>

<script>
import { mapMutations, mapActions, mapState } from 'vuex'
import { updateFaseCarrinhos } from '@/api/carrinho'
import moment from 'moment'
export default {
  props: {
    fecharDialog: Function
  },
  data () {
    return {
      fases: [],
      faseSelecionada: null
    }
  },
  async mounted () {
    this.fases = await this.loadFases()
  },
  computed: {
    ...mapState({
      pedidosSelecionados: state => state.pedidos.pedidosSelecionados,
      pedidos: state => state.pedidos.pedidos
    })
  },
  methods: {
    ...mapMutations({
      setSnackbar: 'global/setSnackbar'
    }),
    ...mapActions({
      loadPedidos: 'pedidos/loadPedidos',
      loadFases: 'ecommerce/loadFases'
    }),
    formatarData (data) {
      return moment(data).format('L LT')
    },
    async selecionarFase () {
      this.$store.state.pedidos.loading = true
      if (this.faseSelecionada) {
        const obj = []
        this.pedidosSelecionados.map(pedido => {
          obj.push({ id: pedido.id, fase_id: this.faseSelecionada })
        })
        try {
          this.fecharDialog()
          await updateFaseCarrinhos(obj)
          await this.loadPedidos({ page: this.pedidos.page, limit: this.pedidos.perPage })
          this.setSnackbar({ msg: 'Pedido(s) atualizado(s) com sucesso!', color: 'green' })
        } catch (error) {
          this.setSnackbar({ msg: `Ocorreu um erro ao atualizar o(s) pedido(s).  ${error}` })
          // console.log(error)
        }
      } else {
        this.setSnackbar({ msg: 'Selecione uma fase para atribuir ao(s) pedido(s) selecionado(s)', color: '#FB8C00' })
      }
      this.$store.state.pedidos.loading = false
    }
  }
}
</script>

<style scoped>
  .fs-box-pedidos-selecionados {
    height: 100%;
    max-height: 105px;
    border: 1px solid #CCC;
    border-radius: 5px;
    padding: 5px;
    padding-left: 10px;
  }
</style>
